module.exports = __webpack_public_path__ + "static/img/image2.5242be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/image2.png
// module id = 1733
// module chunks = 5